import { FeatureCard, Section } from '@pkdigital/pkd-custom-components';
import Image from 'next/image';
import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useClientSide } from '../../utils/useClientSide';
import { MinimumDurationBadge } from './MinimumDurationBadge';
import { useBranding } from '../../hooks/useBranding';
import { Branding } from '../../types';

const ELLIPSE_RED_BLUR = '/td-home/images/landingpage/ellipse_red_blur.png';
const ELLIPSE_BLUE_BLUR = '/td-home/images/landingpage/ellipse_blue_blur.png';

export default function TimelineSection() {
  const { t } = useTranslation();
  const isClient = useClientSide();
  const branding: Branding = useBranding();

  return !isClient ? (
    <></>
  ) : (
    <Container>
      <Section headline={t('timelineSection.title')} className={'timeline'}>
        <div className="timeline-wrapper">
          <div className={'timeline-card card-1'}>
            <div style={{ position: 'relative' }}>
              <FeatureCard
                icon={['pkd', 'thumb-up-regular']}
                title={t('timelineSection.timelineCards.c1.title')}
                description={t('timelineSection.timelineCards.c1.description')}
              />

              <Image
                className="circle"
                src="/td-home/images/landingpage/circle-1-regular.png"
                width={0}
                height={0}
                alt="Step 1"
              />
            </div>
          </div>

          <div className={'timeline-card card-2'}>
            <div style={{ position: 'relative' }}>
              <FeatureCard
                icon={['pkd', 'gauge-simple-high-regular']}
                title={t('timelineSection.timelineCards.c2.title')}
                description={t('timelineSection.timelineCards.c2.description')}
              />
              <Image
                className="circle"
                src="/td-home/images/landingpage/circle-2-regular.png"
                width={0}
                height={0}
                alt="Step 2"
              />
            </div>
          </div>

          <div className={'timeline-card card-3'}>
            <div style={{ position: 'relative' }}>
              <FeatureCard
                icon={['pkd', 'house-signal-regular']}
                title={t('timelineSection.timelineCards.c3.title')}
                description={t('timelineSection.timelineCards.c3.description')}
              />

              <Image
                className="circle"
                src="/td-home/images/landingpage/circle-3-regular.png"
                width={0}
                height={0}
                alt="Step 3"
              />
            </div>
          </div>

          <div className="macbook-wrapper">
            <Image
              className="macbook"
              src="/td-home/images/landingpage/mac_book_pro_17.png"
              width={864}
              height={576}
              alt="Picture of the author"
            />

            <div className="position-relative">
              <Image
                className="ellipse left"
                src={branding === 'hug' ? ELLIPSE_BLUE_BLUR : ELLIPSE_RED_BLUR}
                width={0}
                height={0}
                alt="Picture of the author"
              />
            </div>

            <div className="position-relative">
              <Image
                className="ellipse right"
                src={branding === 'hug' ? ELLIPSE_BLUE_BLUR : ELLIPSE_RED_BLUR}
                width={0}
                height={0}
                alt="Picture of the author"
              />
            </div>

            <div className="position-relative">
              <MinimumDurationBadge />
            </div>
          </div>

          <div className={'timeline-card card-4'}>
            <div style={{ position: 'relative' }}>
              <FeatureCard
                icon={['pkd', 'laptop-mobile-regular']}
                title={t('timelineSection.timelineCards.c4.title')}
                description={t('timelineSection.timelineCards.c4.description')}
              />
              <Image
                className="circle"
                src="/td-home/images/landingpage/circle-4-regular.png"
                width={0}
                height={0}
                alt="Step 4"
              />
            </div>
          </div>
          <div className={'timeline-card card-5'}>
            <div style={{ position: 'relative' }}>
              <FeatureCard
                button={{
                  children: 'Mehr Infos',
                  href: 'https://www.techem.com/de/de/abrechnung/abrechnung-direct',
                  target: '_blank',
                  // @ts-ignore prettier-ignore
                  fillMode: 'link',
                  icon: 'arrow-right-long',
                  iconPosition: 'end'
                }}
                size="regular"
                icon={['pkd', 'handshake-angle-regular']}
                title={t('timelineSection.timelineCards.c5.title')}
                description={t('timelineSection.timelineCards.c5.description')}
              />
              <Image
                className="circle"
                src="/td-home/images/landingpage/circle-5-regular.png"
                width={0}
                height={0}
                alt="Step 5"
              />
            </div>
          </div>
        </div>
      </Section>
    </Container>
  );
}
